// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__32PEM","list":"BalanceDue_list__3ERsP","listRow":"BalanceDue_listRow__e32nY","total":"BalanceDue_total__Kwurz"};